
import { Component } from "@angular/core";
import { AppCommonModule } from "@app/components/app.common.module";
import { SelectClientModalWrapperComponent } from "@app/components/client-select-modal-wrapper/client-select-modal-wrapper.component";

@Component({
  selector: 'app-client-select-modal',
  standalone: true,
  imports: [AppCommonModule],
  templateUrl: './client-select-modal.component.html',
  styleUrl: './client-select-modal.component.scss'
})
export class SelectClientModalComponent extends SelectClientModalWrapperComponent {

}
